import type React from 'react'
import type { JSX } from 'react'
import type { TextBoxColors } from 'atoms/TextBox'
import type { FIXED_INDENTS, LAYOUT } from 'vars/index'

import {
  ContainerDescriptionAlignItems,
  ContainerDescriptionAspectRatio,
  ContainerDescriptionColumnGap,
  ContainerDescriptionDirection,
  ContainerDescriptionJustifyContent,
  ContainerDescriptionRowGap,
} from './ContainerDescription.h'
import { ContainerDescriptionStyled } from './ContainerDescription.styled'

export interface IContainerDescriptionProps {
  children: React.ReactNode
  width?: number
  direction?: ContainerDescriptionDirection
  alignItems?: ContainerDescriptionAlignItems
  justifyContent?: ContainerDescriptionJustifyContent
  columnGap?: ContainerDescriptionColumnGap
  rowGap?: ContainerDescriptionRowGap
  color?: TextBoxColors
  aspectRatio?: ContainerDescriptionAspectRatio
  paddings?: Array<FIXED_INDENTS | LAYOUT>
}

export const ContainerDescription = ({
  children,
  width = 0,
  direction = ContainerDescriptionDirection.Column,
  alignItems = ContainerDescriptionAlignItems.FlexStart,
  justifyContent = ContainerDescriptionJustifyContent.FlexStart,
  columnGap = ContainerDescriptionColumnGap.INDENT_0,
  rowGap = ContainerDescriptionRowGap.INDENT_0,
  aspectRatio = ContainerDescriptionAspectRatio.HORIZONTAL_DEFAULT,
  color,
  paddings,
}: IContainerDescriptionProps): JSX.Element => (
  <ContainerDescriptionStyled
    width={width}
    direction={direction}
    alignItems={alignItems}
    justifyContent={justifyContent}
    columnGap={columnGap}
    rowGap={rowGap}
    colorDefault={color}
    aspectRatio={aspectRatio}
    paddings={paddings}
  >
    {children}
  </ContainerDescriptionStyled>
)
